export enum AxisType {
	NULL = 'null',
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}

export enum DirectionType {
	NULL = 'null',
	LEFT = 'left',
	RIGHT = 'right',
	UP = 'up',
	DOWN = 'down'
}
